export default __webpack_public_path__ + "static/media/black.7e82bab5.png";